<div class="cell-content"><ng-content></ng-content></div>
